import React, { Component } from 'react';
import EquipSelect from '~/components/common/EquipSelect';
import RegionSelect from '../RegionSelect';
import Button from '~/components/common/Button';
import { ModeType } from '~/pages/CapacityRatio/modelData';
import css from './style.css';
import cs from 'classnames';

export default class RatioHeader extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      equipmentValue,
      regionValue,
      modelType = ModeType.LIST,
      modelTypeChangeHandler,
      regionHandel,
      equipmentHandel,
    } = this.props;

    return (
      <div
        className={cs(css.RatioHeaderWarp, {
          [css.RatioHeaderWarpMap]: modelType === ModeType.MAP,
        })}>
        <div className={css.RatioFilter}>
          <div>
            <span className={css.RatioLabel}>Trailer Type</span>
            <EquipSelect
              wrapClassName={css.EquipSelectWarp}
              value={equipmentValue}
              dropDownId='equipment'
              onChange={equipmentHandel}
              limit={1}
            />
          </div>
          <div className={css.RegionSelectWarp}>
            <span className={css.RatioLabel}>Region</span>
            <RegionSelect
              value={regionValue}
              dropDownId='region'
              onChange={regionHandel}
            />
          </div>
        </div>
        <div className={css.ButtonWarp}>
          <Button
            mods={['small']}
            className={cs(css.ModeType, {
              [css.ActiveMode]: modelType === ModeType.LIST,
            })}
            onClick={modelTypeChangeHandler(ModeType.LIST)}>
            List
          </Button>
          <Button
            mods={['small']}
            className={cs(css.ModeType, {
              [css.ActiveMode]: modelType === ModeType.MAP,
            })}
            onClick={modelTypeChangeHandler(ModeType.MAP)}>
            Map
          </Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/CapacityRatio/compontents/RatioHeader/index.js